const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

const BASE = API_URL + '/api/comments'

export interface CommentDto {
  id: string
  firstName: string
  lastName: string
  text: string
  likes: number
  dislikes: number
  isReported: boolean
  createdAt: string
  replies: CommentDto[]
}

export async function fetchComments(newsId: string): Promise<CommentDto[]> {
  try {
    const res = await fetch(`${BASE}/${newsId}`)
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}

export async function createComment(body: {
  newsId: string
  parentCommentId?: string | null
  firstName: string
  lastName: string
  email: string
  text: string
}): Promise<CommentDto | null> {
  try {
    const res = await fetch(BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function reactComment(id: string, type: 'like' | 'dislike' | 'none', previous: 'like' | 'dislike' | 'none'): Promise<{ likes: number; dislikes: number } | null> {
  try {
    const res = await fetch(`${BASE}/${id}/react?type=${type}&previous=${previous}`, { method: 'POST' })
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function reportComment(id: string): Promise<boolean> {
  try {
    const res = await fetch(`${BASE}/${id}/report`, { method: 'POST' })
    return res.ok
  } catch {
    return false
  }
}
